import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { SolicitudDesembolsoService } from '../../../services/operaciones/solicitud-desembolso/solicitud-des.service';
import { SolicitudDesembolso } from '../../../models/SolicitudDesembolso';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-solicitud-des-detalle',
  templateUrl: './solicitud-des-detalle.component.html',
  styleUrls: ['./solicitud-des-detalle.component.scss']
})
export class SolicitudDesDetalleComponent implements OnInit {
  @Output() cerrarSoliDesDetalle : EventEmitter<boolean> = new EventEmitter();
  @Input() idSolicitudDesembolso:number = 0;

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  
  SolicitudDesembolso : SolicitudDesembolso = new SolicitudDesembolso();
  //SolicitudDesembolsoDetalle : SolicitudDesembolsoDetalle = new SolicitudDesembolsoDetalle();
  SoliDesDetalle2: any;
  loading:boolean;
  loading1:boolean;
  loading2:boolean;

  tDocs:number;
  tAdelanto: number;
  tSolicitado: number;
  tPendiente: number;
  tInteres: number;
  tComision: number;
  tIgv: number;
  tDesembolso: number;
  tRemanente: number;

  constructor(private solicitudDesembolsoService : SolicitudDesembolsoService){}

  ngOnInit(){
      this.obtenerSoliDesembolsoPorId();
  }


  MetcerrarSoliDesDetalle(){
      this.cerrarSoliDesDetalle.emit();
  }


  obtenerSoliDesembolsoPorId(){
      this.loading = true;
      this.solicitudDesembolsoService.ObtenerDesembolsoPorId(this.idSolicitudDesembolso).subscribe(
        res =>{
            let data: any = res;
            this.SolicitudDesembolso = data as SolicitudDesembolso;
            this.SoliDesDetalle2 = data.Detail;
            this.tDocs = this.SoliDesDetalle2.length;
            this.tAdelanto = this.SoliDesDetalle2.reduce((acc,obj) => acc + obj.Adelanto_importe_OD*1 - obj.Adelanto_ejecutado_OD*1 + obj.Adelanto_Importe*1,0);
            this.tSolicitado = this.SoliDesDetalle2.reduce((acc,obj) => acc + obj.Adelanto_Importe*1,0);
            this.tPendiente = this.SoliDesDetalle2.reduce((acc,obj) => acc + obj.Adelanto_Pendiente_Importe_OD*1,0);

            this.tInteres = this.SoliDesDetalle2.reduce((acc,obj) => acc + obj.Interes_Proveedor * 1 + obj.Interes_Adquirente * 1,0);
            this.tComision = this.SoliDesDetalle2.reduce((acc,obj) => acc + obj.Comision_Proveedor*1,0);
            this.tIgv = this.SoliDesDetalle2.reduce((acc,obj) => acc + obj.IGV_Importe_Proveedor*1,0);
            this.tDesembolso = this.SoliDesDetalle2.reduce((acc,obj) => acc + obj.Desembolso_Importe*1,0);
            this.tRemanente = this.SoliDesDetalle2.reduce((acc,obj) => acc + obj.Remanente_importe_OD*1,0);
            this.loading = false;
      },err => {
        this.loading = false;
        this.MetcerrarSoliDesDetalle();
      });    
  }
}